module.exports = __webpack_public_path__ + "static/scale-model-of-union-station-in-houston-texas-2f6b519915d097a09f9fa0ee6021b7be.png";